import { useEffect } from "react";
import { useLocation, Link } from "wouter";
import { FirebaseAuth } from "@/components/FirebaseAuth";
import { useAuth } from "@/_core/hooks/useAuth";
import { toast } from "sonner";
// import { SentryTestButton } from "@/components/SentryTestButton"; // Uncomment to test Sentry

export default function Login() {
  const [, setLocation] = useLocation();
  const { user, loading } = useAuth();

  // Redirect if already authenticated
  useEffect(() => {
    if (user && !loading) {
      setLocation("/dashboard");
    }
  }, [user, loading, setLocation]);

  const handleSuccess = () => {
    toast.success("Successfully signed in!");
    // The useAuth hook will automatically detect the user and redirect
    setTimeout(() => {
      setLocation("/dashboard");
    }, 500);
  };

  const handleError = (error: Error) => {
    console.error("Login error:", error);
    toast.error("Failed to sign in. Please try again.");
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[var(--background)] via-[var(--muted)] to-[var(--card)]">
        <div className="text-center" role="status" aria-live="polite">
          <div
            className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"
            aria-hidden="true"
          />
          <p className="text-muted-foreground">Loading...</p>
          <span className="sr-only">
            Please wait while we check your authentication status
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[var(--background)] via-[var(--muted)] to-[var(--card)]">
      <main className="w-full max-w-md px-4">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-foreground mb-2">
            Swiss Tax Platform
          </h1>
          <p className="text-muted-foreground">
            Corporate tax management for Kanton Zürich
          </p>
        </div>

        <FirebaseAuth onSuccess={handleSuccess} onError={handleError} />

        <footer className="mt-6 text-center text-sm text-muted-foreground">
          <p>
            By signing in, you agree to our{" "}
            <Link href="/terms" className="text-primary hover:underline">
              Terms of Service
            </Link>{" "}
            and{" "}
            <Link href="/privacy" className="text-primary hover:underline">
              Privacy Policy
            </Link>
          </p>
        </footer>

        {/* Sentry Test Button - for debugging (uncomment to test)
        <div className="mt-4 text-center">
          <SentryTestButton />
        </div>
        */}
      </main>
    </div>
  );
}
